import React from 'react';
import './AuroraBackground.css';

/**
 * Fixed full-screen backdrop: drifting aurora blobs over a faint grid.
 * Purely decorative — hidden from assistive tech.
 */
export default function AuroraBackground() {
  return (
    <div className="aurora" aria-hidden="true">
      <div className="aurora__blob aurora__blob--violet" />
      <div className="aurora__blob aurora__blob--cyan" />
      <div className="aurora__blob aurora__blob--pink" />
      <div className="aurora__grid" />
    </div>
  );
}
